// extracted by mini-css-extract-plugin
export var chip = "_a5-0";
export var filterDropdown = "_a5-5";
export var filterItem = "_a5-6";
export var icon = "_a5-1";
export var removeButton = "_a5-3";
export var removeIcon = "_a5-4";
export var separator = "_a5-2";